// Temp Work around for coming soon link offsite
document.addEventListener("DOMContentLoaded", () => {
  try {
    const elementsWithTitle = document.querySelectorAll('[title]');
    
    if (!elementsWithTitle.length) {
      return;
    }

    elementsWithTitle.forEach(element => {
      try {
        if (element.getAttribute('title') === 'Coming Soon') {
          if (element.tagName === 'A' && element.href) {
            element.href = 'https://info.alphaleteathletics.com/pages/aa25-june';
          } else {
            return;
          }
        }
      } catch (innerError) {
        return;
      }
    });
  } catch (error) {
    return;
  }
});
